import { CustomerProfile } from '@/features/customers';
import { Outlet, createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/customers/$leadId'
)({ component: CustomerProfilePage });
/** The profile stays mounted beneath read-only child dialogs. */
function CustomerProfilePage() {
  const { leadId } = Route.useParams();
  return (
    <>
      <title>Customer | Borrah</title>
      <CustomerProfile leadId={leadId} />
      <Outlet />
    </>
  );
}
